import FlagsApi from '../api/FlagsApi';
import FlagsConstants from '../constants/FlagsConstants';

function addFlag({ contentId, userId, flagType, reason, violationType, postSuccess }) {
  return {
    contentId,
    types: [FlagsConstants.ADD_FLAG_REQUEST, FlagsConstants.ADD_FLAG_SUCCESS, FlagsConstants.ADD_FLAG_FAILURE],
    apiRequest: (state, client) => FlagsApi.addFlag({ contentId, userId, flagType, reason, violationType }, client),
    postSuccess
  };
}

export default {
  addFlag
};
